export function canPerformRequestAction(editRequest, currentUser, action) {
  if (!editRequest || !currentUser) {
    return { allowed: false, message: "Invalid data" };
  }

  const requestUserId = editRequest.userId || editRequest.uid || null;
  const requestRole = editRequest.role || null;
  const currentUserId = currentUser.uid || null;
  const currentUserRole = currentUser.role || null;
  const currentUserIsSuperAdmin = currentUser.isSuperAdmin === true;

  if (requestUserId && requestUserId === currentUserId) {
    return { allowed: false, message: `You cannot ${action} your own data` };
  }

  if (requestRole && requestRole === currentUserRole) {
    console.log("current user isAdmin", currentUser, " IS ADMIN", currentUserIsSuperAdmin)
    if (!currentUserIsSuperAdmin) {
      return { 
        allowed: false, 
        message: `You cannot ${action} a request from a user with the same role as yours`
      };
    }
  }

  return { allowed: true, message: "" };
}



// WEBPACK FOOTER //
// ./src/utils/index.js